
namespace RioERP.Orders {
    export class BrandAmbassadorPaymentsColumns {
        static columnsKey = 'Orders.BrandAmbassadorPayments';
    }
}